import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { API } from 'javascripts/api'
import { SubmitHandler } from 'react-hook-form'
import { ClientContractExtensionRequest, UpdateClientContractExtensionRequest } from 'javascripts/api/generated'
import { StyledClientContractExtensionRequests } from './styled'
import ClientLayout from 'spa/client/layouts/ClientLayout'
import { useFlash } from 'spa/hooks/useFlash'

const ClientContractExtensionRequests: React.FC = () => {
  const [flash, setFlash] = useFlash()
  const navigate = useNavigate()
  const pathItems: string[] = location.pathname.split('/')
  const accessToken: string = pathItems[pathItems.length - 1]
  const [data, setData] = useState<ClientContractExtensionRequest>()

  const onSubmit: SubmitHandler<UpdateClientContractExtensionRequest> = (data) => {
    API.updateClientContractExtensionRequest(accessToken, data).then((response) => {
      navigate('/clients/contract_extension_requests/update')
    }).catch((error) => {
      if (API.isAxiosError(error)) {
        setFlash({ ...flash, alert: error.message })
      }
    })
  }

  useEffect(() => {
    let ignore = false

    API.getClientContractExtensionRequest(accessToken, undefined).then((response) => {
      const responseData: ClientContractExtensionRequest = response.data
      if (!ignore) setData(responseData)
    }).catch((error) => {
      if (API.isAxiosError(error)) {
        if (API.isUnauthorizedError(error.response)) {
          navigate('/client_auth/login', {
            state: {
              flash: { error: 'ログインしてください。' },
              backTo: location.pathname,
            }
          })
        }
        else if (API.isNotFoundError(error.response)) {
          navigate('/clients/home', {
            state: {
              flash: { error: '該当のアンケートが見つかりませんでした。' },
              backTo: location.pathname,
            }
          })
        }
      }
    })
    return () => { ignore = true }
  }, [])

  if (!data) {
    return <ClientLayout><div>読み込み中</div></ClientLayout>
  }
  return (
    <StyledClientContractExtensionRequests
      description={data.contractExtensionRequest.contract.description}
      userFullName={data.contractExtensionRequest.contract.userFullName}
      qaItems={data.contractExtensionRequest.extensionSurveyAnswer}
      onSubmit={onSubmit}
    />
  )
}

export default ClientContractExtensionRequests
